import { Event, Response } from "@jupiter/types";
import { Logger } from "@jupiter/utils";
import isUndefined from "lodash-es/isUndefined";
import { BaseTransport } from "@jupiter/core";

/** `XHR` based transport */
export class XHRTransport extends BaseTransport {
  /**
   * @inheritDoc
   */
  public sendEvent(event: Event): PromiseLike<Response> {
    return this._sendRequest(event);
  }

  private _sendRequest(event: Event) {
    if (isUndefined(event)) {
      const reason = "[_sendRequest] event is undefined, skip";
      return Promise.resolve(reason as any);
    }

    return new Promise<Response>((resolve, _reject) => {
      try {
        const req = new XMLHttpRequest();
        const endpoint = this._api.getEndpoint();
        req.open("POST", endpoint, true);

        const headers: Record<string, string> = {};
        headers["Content-Type"] = "application/x-www-form-urlencoded";
        Object.keys(headers).forEach((key) =>
          req.setRequestHeader(key, headers[key])
        );

        const timeout: number = 10000;
        let startTime: number;
        if (timeout && typeof req.timeout !== "undefined") {
          req.timeout = timeout;
          startTime = new Date().getTime();
        }

        req.onreadystatechange = function () {
          if (req.readyState === 4) {
            if (req.status == 200) {
              try {
                const res = JSON.parse(req.responseText);
                const { status } = res;

                if (status != "0") {
                  const { error } = res;
                  resolve({ error, status, event });
                } else {
                  resolve({ status, res, event });
                }
              } catch (_oO) {
                Logger.error(`event request send error: `, _oO);
                // reject(_oO);s
              }
            } else {
              let reason;

              if (
                req.timeout &&
                !req.status &&
                new Date().getTime() - startTime >= req.timeout
              ) {
                reason = "Timeout";
              } else {
                reason = `Bad HTTP status: ${req.status} ${req.statusText}`;
              }

              Logger.error(`event request send error: `, reason);
              // reject(reason);s
            }
          }
        };

        const data = new URLSearchParams();
        data.append("content", JSON.stringify(event));
        req.send(data);

        Logger.log("event tracked: ", event);
      } catch (_oO) {
        Logger.error("event request send error", _oO);
        // reject(_oO);
      }
    });
  }
}
